import React from 'react';

// Shared pure/presentational helpers for the Leave Management screens.
// Kept at module scope (not re-created every render) and imported both by
// LeaveManagement.jsx and its extracted row components so the badge/label
// logic stays in one place.

export const getStatusBadge = (status) => {
  const badges = {
    pending: { class: 'status-pending', text: 'Pending' },
    approved: { class: 'status-approved', text: 'Approved' },
    rejected: { class: 'status-rejected', text: 'Rejected' }
  };
  const badge = badges[status] || badges.pending;
  return <span className={`status-badge ${badge.class}`}>{badge.text}</span>;
};

export const getLeaveTypeLabel = (type) => {
  const labels = {
    sick: '🤒 Sick',
    casual: '🏖️ Casual',
    emergency: '🚨 Emergency',
    informed: '📢 Informed',
    uninformed: '⚠️ Uninformed',
    other: '📝 Other'
  };
  return labels[type] || type;
};

export const getPaymentStatusBadge = (paymentStatus) => {
  if (paymentStatus === 'paid') {
    return <span className="payment-badge paid">💰 Paid</span>;
  } else if (paymentStatus === 'unpaid') {
    return <span className="payment-badge unpaid">🚫 Unpaid</span>;
  } else {
    return <span className="payment-badge pending">⏳ Pending</span>;
  }
};
